const decimalToAlpha = (dec) => {
  const clamped = Math.max(Math.min(Math.ceil(255 * dec), 255), 0)
  return clamped.toString(16)
}

export default decimalToAlpha
